import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import WhiteLogo from "../../assets/images/whitelogo.png";
import "@fontsource-variable/nunito";
import "../../style/admin-ui.css";
import "../../style/admin-sidebar.css";

// Sidebar bersama untuk dashboard Admin, Attendance, dan Class Assistant.
// Yang berbeda hanya isi menu, tombol switch, aksen warna (variant), dan cara
// logout — dikirim lewat props oleh SidebarAdmin / SidebarAttendance /
// SidebarAssistant.
//
// Komponen ini juga memasang class "adm-body" di <body> selama halaman admin
// terbuka, supaya gaya bersama di admin-ui.css (form, tabel, dialog
// SweetAlert) hanya berlaku di area admin, bukan di website publik.
const isActive = (pathname, item) => {
  const current = pathname.toLowerCase();
  const paths = [item.path, ...(item.alsoActiveOn || [])].map((p) => p.toLowerCase());
  return paths.some((p) => current === p || (p !== "/" && current.startsWith(`${p}/`)));
};

const AdminSidebar = ({ items, variant = "main", switchButton, onLogout, isMobileAdmin }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add("adm-body");
    document.body.classList.toggle("adm-attendance", variant !== "main");
    return () => {
      document.body.classList.remove("adm-body", "adm-attendance");
    };
  }, [variant]);

  // Tutup drawer mobile setiap kali pindah halaman.
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout",
      text: "Are you sure you want to log out?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) onLogout();
  };

  return (
    <>
      {isMobileAdmin && (
        <button type="button" className="adm-sb-toggle" aria-label="Open menu" onClick={() => setOpen(true)}>
          <i className="bi bi-list"></i>
        </button>
      )}
      {isMobileAdmin && open && <div className="adm-sb-backdrop" onClick={() => setOpen(false)} />}

      <aside
        className={`adm-sb adm-sb--${variant}${isMobileAdmin ? " adm-sb--mobile" : ""}${open ? " adm-sb--open" : ""}`}
      >
        {isMobileAdmin && (
          <button type="button" className="adm-sb-close" aria-label="Close menu" onClick={() => setOpen(false)}>
            <i className="bi bi-x-lg"></i>
          </button>
        )}

        <div className="adm-sb-brand">
          <img src={WhiteLogo} alt="Cutting Edge Academy" />
          <div>
            <p className="adm-sb-brand-name">Cutting Edge</p>
            <p className="adm-sb-brand-area">
              {variant === "main" ? "Admin" : variant === "assistant" ? "Class Assistant" : "Attendance"}
            </p>
          </div>
        </div>

        {switchButton && (
          <button type="button" className="adm-sb-switch" onClick={() => go(switchButton.path)}>
            <i className="bi bi-arrow-left-right"></i> {switchButton.label}
          </button>
        )}

        <nav className="adm-sb-nav">
          {items.map((item) => (
            <button
              key={item.path}
              type="button"
              className={`adm-sb-link${isActive(pathname, item) ? " adm-sb-link--active" : ""}`}
              onClick={() => go(item.path)}
            >
              <i className={`bi ${item.icon}`}></i>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <button type="button" className="adm-sb-link adm-sb-logout" onClick={handleLogout}>
          <i className="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </aside>
    </>
  );
};

export default AdminSidebar;
